import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import FilterGroupValueMessage from 'components/FilterGroupValueMessage';
import OperandShorthand from 'components/OperandShorthand';
import cx from 'classnames';
import ButtonUnstyled from 'components/ButtonUnstyled';
import './FilterList.css';

const editTitle = (
  <FormattedMessage
    id="FilterList__ItemEditFilter"
    description="Label for editing an existing filter"
    defaultMessage="Edit Filter"
  />
);

export const FilterListGroupItem = ({
  onClick,
  selected,
  selectedFilterGroupIds,
  filterGroups,
}) => {
  return (
    <div
      className={cx({
        FilterList__Item: true,
        'FilterList__Item--selected': selected,
      })}
      onClick={onClick}
    >
      {selected ? (
        <div className="FilterList__ItemTitle">{editTitle}</div>
      ) : (
        <div className="FilterList__ItemContent">
          <div className="FilterList__ItemTitle">
            <FormattedMessage
              id="FilterList__GroupItemTitle"
              description="Label for PDP picker in filter list"
              defaultMessage="PDP Policy"
            />
          </div>
          <div className="FilterList__ItemValue">
            <FilterGroupValueMessage
              totalCount={filterGroups.length}
              enabledCount={selectedFilterGroupIds.length}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const AppliedFilterListItem = ({filter}) => (
  <div className="FilterList__ItemContent">
    <div className="FilterList__ItemTitle">{filter.label}</div>
    <div className="FilterList__ItemValue">
      <OperandShorthand value={filter.operand} /> {filter.values.join(', ')}
    </div>
  </div>
);

const UnappliedFilterListItem = ({filter}) => (
  <div className="FilterList__ItemContent">
    <div className="FilterList__ItemTitle">{filter.label}</div>
    <div className="FilterList__ItemValue">
      <FormattedMessage
        id="FilterList__ItemUnapplied"
        description="Description of unapplied filter"
        defaultMessage="unset"
      />
    </div>
  </div>
);

const FilterListItem = ({filter, selected, onClick}) => (
  <ButtonUnstyled
    className={cx({
      FilterList__Item: true,
      'FilterList__Item--selected': selected,
    })}
    onClick={onClick.bind(null, filter)}
  >
    {filter.applied ? (
      selected ? (
        <div className="FilterList__ItemTitle">{editTitle}</div>
      ) : (
        <AppliedFilterListItem filter={filter} />
      )
    ) : (
      <UnappliedFilterListItem filter={filter} />
    )}
  </ButtonUnstyled>
);

const FilterList = ({selectedFilter, filters, onFilterSelect, children}) => (
  <div className="FilterList">
    {filters.map(f => (
      <FilterListItem
        key={f.id}
        filter={f}
        selected={selectedFilter === f}
        onClick={onFilterSelect}
      />
    ))}
    {children}
  </div>
);

FilterList.propTypes = {
  selectedFilter: PropTypes.object,
  filters: PropTypes.array.isRequired,
  onFilterSelect: PropTypes.func.isRequired,
};

export default FilterList;
